// extracted by mini-css-extract-plugin
module.exports = {"bidText":"Winner_bidText__1X1rH","addressText":"Winner_addressText__1SOEy","ethAddressPadding":"Winner_ethAddressPadding__1XsHp","partyWonText":"Winner_partyWonText__2-yHy"};